document.querySelectorAll('.quiz-block').forEach((block) => {
    const screens          = block.querySelectorAll('[data-quiz-screen]');
    const screenIntro      = block.querySelector('[data-quiz-screen="intro"]');
    const screenQuestions  = block.querySelector('[data-quiz-screen="questions"]');
    const screenGate       = block.querySelector('[data-quiz-screen="gate"]');
    const screenResults    = block.querySelector('[data-quiz-screen="results"]');
    const questionEls      = block.querySelectorAll('.quiz-question');
    const progressFill     = block.querySelector('[data-quiz-progress-fill]');
    const currentQLabel    = block.querySelector('[data-quiz-current-q]');
    const totalQ           = questionEls.length;

    let scores       = [];
    let currentIndex = 0;
    let pendingScore = 0;

    const showScreen = (target) => {
        screens.forEach((s) => {
            const active = s === target;
            s.classList.toggle('is-active', active);
            s.setAttribute('aria-hidden', String(!active));
        });
        block.scrollIntoView({ behavior: 'smooth', block: 'start' });
    };

    const showQuestion = (index) => {
        questionEls.forEach((q, i) => {
            const active = i === index;
            q.classList.toggle('is-active', active);
            q.setAttribute('aria-hidden', String(!active));
        });
        if (currentQLabel) currentQLabel.textContent = index + 1;
        if (progressFill)  progressFill.style.width = `${(index / totalQ) * 100}%`;
    };

    const hideAllForms = () => {
        block.querySelectorAll('.quiz-form-panel').forEach((p) => { p.classList.remove('is-visible'); });
    };

    const showForm = (formKey) => {
        const panel = block.querySelector(`[data-form-panel="${formKey}"]`);
        if (!panel) return;
        hideAllForms();
        panel.classList.add('is-visible');
    };

    const showResult = (totalScore) => {
        block.querySelectorAll('.quiz-result').forEach((r) => {
            const min   = parseInt(r.dataset.min, 10);
            const max   = parseInt(r.dataset.max, 10);
            const match = totalScore >= min && totalScore <= max;
            r.classList.toggle('is-active', match);
            r.setAttribute('aria-hidden', String(!match));
        });
        if (progressFill) progressFill.style.width = '100%';
        hideAllForms();
        showScreen(screenResults);
    };

    block.addEventListener('click', (e) => {
        // Start button
        if (e.target.closest('.quiz-start-btn')) {
            scores       = [];
            currentIndex = 0;
            showQuestion(0);
            showScreen(screenQuestions);
            return;
        }

        // Retake button
        if (e.target.closest('.quiz-retake-btn')) {
            scores       = [];
            currentIndex = 0;
            pendingScore = 0;
            block.querySelectorAll('.quiz-answer.selected').forEach((a) => a.classList.remove('selected'));
            hideAllForms();
            showQuestion(0);
            showScreen(screenIntro);
            return;
        }

        // Continue past the results gate
        if (e.target.closest('.quiz-gate-continue-btn')) {
            showResult(pendingScore);
            return;
        }

        // Close a form panel
        if (e.target.closest('.quiz-form-close')) {
            hideAllForms();
            return;
        }

        // Open a form panel
        const formBtn = e.target.closest('[data-form]');
        if (formBtn) {
            showForm(formBtn.dataset.form);
            return;
        }

        // Answer selection
        const answer = e.target.closest('.quiz-answer');
        if (answer) {
            answer.classList.add('selected');
            setTimeout(() => {
                scores.push(parseInt(answer.dataset.score, 10));
                if (currentIndex < totalQ - 1) {
                    currentIndex++;
                    showQuestion(currentIndex);
                    block.querySelectorAll('.quiz-answer.selected').forEach((a) => a.classList.remove('selected'));
                } else {
                    const total = scores.reduce((sum, s) => sum + s, 0);
                    if (screenGate) {
                        pendingScore = total;
                        showScreen(screenGate);
                    } else {
                        showResult(total);
                    }
                }
            }, 300);
        }
    });
});
